export interface AddOnIcon {
  name: string
  label: string
  icon: () => JSX.Element
  category: 'trademark' | 'patent' | 'renewal'
  description?: string
  price: number | Record<string, number>
  per?: string | Record<string, 'month' | 'year' | 'quarter'>
  priceType: 'direct' | 'type_based'
  monthlyValue?: ({
    count,
    type,
    freeTrialCount,
  }: {
    count: number
    type?: any
    freeTrialCount?: number
  }) => number
  yearlyValue?: ({
    count,
    type,
    freeTrialCount,
  }: {
    count: number
    type?: any
    freeTrialCount?: number
  }) => number
}

export const AddOnsInfo: AddOnIcon[] = [
  {
    name: 'apparel',
    label: 'Apparel',
    category: 'trademark',
    description: 'Custom designed t-shirts with a name or logo of your brand.',
    price: 400,
    priceType: 'direct',
    icon: () => (
      <svg
        width="16"
        height="14"
        viewBox="0 0 16 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.7653 5.07904L11.529 0.353882H4.64938L0.413086 5.07904L2.65797 8.17492L3.97961 7.23347L3.92528 13.3891H12.2534L12.1991 7.23347L13.5207 8.17492L15.7653 5.07904ZM9.35617 1.43997C9.21137 2.34514 8.52339 3.28659 8.08886 3.28659C7.65433 3.28659 6.96634 2.34527 6.82155 1.43997H9.35617ZM11.0941 5.0971L11.1485 12.3027H5.02925L5.08358 5.0971L2.9111 6.65415L1.8068 5.15144L5.13792 1.44012H5.73542C5.88022 2.61698 6.76733 4.373 8.08897 4.373C9.41062 4.37312 10.2977 2.61695 10.4425 1.44012H11.0399L14.371 5.15144L13.2667 6.65415L11.0941 5.0971Z"
          fill="black"
        />
      </svg>
    ),
  },
  {
    name: 'video_production',
    label: 'Video Production',
    category: 'trademark',
    description:
      'We create promotional, live event, crowdfunding, & instructional videos for your business.',
    price: {
      basic: 1000,
      plus: 2500,
      gold: 5000,
    },
    priceType: 'type_based',
    icon: () => (
      <svg
        width="23"
        height="23"
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.80369 1.50825C5.6855 1.50788 5.57189 1.55466 5.48835 1.6382C5.40469 1.72186 5.35791 1.83535 5.3584 1.95354V16.1474C5.35865 16.2652 5.40568 16.3781 5.48922 16.4611C5.57275 16.5442 5.68587 16.5906 5.80369 16.5901H16.3762C16.6202 16.5892 16.8176 16.3915 16.818 16.1474V5.58785C16.8225 5.52808 16.8148 5.46793 16.7955 5.41112C16.7935 5.40531 16.7916 5.39961 16.7894 5.39392C16.7872 5.38835 16.7849 5.38291 16.7825 5.37746C16.78 5.37189 16.7774 5.36645 16.7747 5.361C16.7694 5.34974 16.7636 5.33885 16.7574 5.32808V5.32721C16.7543 5.32189 16.7511 5.31669 16.7479 5.31162C16.7444 5.30692 16.7409 5.30221 16.7375 5.29763C16.7362 5.2959 16.7351 5.29417 16.7339 5.29244C16.7317 5.28922 16.7293 5.28612 16.7269 5.28291C16.725 5.28031 16.723 5.27771 16.7209 5.27511C16.7189 5.27276 16.7169 5.27041 16.7148 5.26818C16.7071 5.2589 16.699 5.24999 16.6906 5.24132L13.0892 1.639C13.0652 1.61622 13.0388 1.59617 13.0104 1.57922C13.0011 1.57316 12.9915 1.56734 12.9818 1.56189C12.955 1.54754 12.9268 1.5359 12.8977 1.52724C12.8855 1.52415 12.873 1.52155 12.8605 1.51944C12.8417 1.51548 12.8225 1.51288 12.8033 1.51152C12.7938 1.51004 12.7842 1.50892 12.7747 1.50806L5.80369 1.50825ZM6.24551 2.39537H12.3299V5.55572C12.3309 5.80077 12.5302 5.99855 12.7752 5.99753H15.9312V15.702H6.24576L6.24551 2.39537ZM13.217 3.02173L14.2583 4.06305L15.3031 5.11045H13.217V3.02173ZM7.60502 6.30153C7.48719 6.30116 7.37408 6.34757 7.29054 6.43061C7.207 6.51366 7.15997 6.62652 7.15972 6.74422V8.31226C7.15923 8.43058 7.20601 8.54406 7.28967 8.62773C7.37321 8.71126 7.48683 8.75805 7.60502 8.75755H9.17306C9.41798 8.75669 9.61576 8.55731 9.61487 8.31225V6.74421C9.61438 6.50028 9.41698 6.30252 9.17306 6.30151L7.60502 6.30153ZM10.9517 7.08469C10.8338 7.08494 10.721 7.1321 10.6379 7.21563C10.5549 7.29917 10.5085 7.41229 10.509 7.52999C10.51 7.77404 10.7077 7.97145 10.9517 7.9718H14.5755C14.6931 7.9723 14.8062 7.92601 14.8897 7.84321C14.9732 7.76029 15.0203 7.64767 15.0208 7.52998C15.0213 7.41178 14.9746 7.2983 14.8909 7.21464C14.8073 7.1311 14.6937 7.08432 14.5755 7.08469L10.9517 7.08469ZM8.04686 7.18952H8.72779V7.87045H8.04686V7.18952ZM7.60505 9.40905C7.36012 9.40819 7.16076 9.60596 7.15975 9.85087V11.4198C7.16074 11.6648 7.36011 11.8626 7.60505 11.8616H9.17309C9.41665 11.8607 9.61392 11.6635 9.6149 11.4198V9.85087C9.61391 9.60731 9.41664 9.41004 9.17309 9.40905H7.60505ZM10.9517 10.1913C10.8337 10.1916 10.7208 10.2389 10.6377 10.3225C10.5547 10.4063 10.5083 10.5195 10.509 10.6375C10.51 10.8815 10.7078 11.079 10.9517 11.0793H14.5756C14.6931 11.0798 14.8063 11.0335 14.8897 10.9507C14.9732 10.8678 15.0204 10.7552 15.0209 10.6375C15.0216 10.5192 14.9748 10.4054 14.8913 10.3216C14.8076 10.2379 14.694 10.1909 14.5756 10.1913L10.9517 10.1913ZM8.04689 10.2962H8.72782V10.978H8.04689V10.2962ZM7.60508 12.5165C7.36016 12.5157 7.16079 12.7134 7.15978 12.9584V14.5273C7.16077 14.7723 7.36015 14.9701 7.60508 14.9691H9.17312C9.41668 14.9682 9.61395 14.771 9.61494 14.5273V12.9584C9.61395 12.7148 9.41667 12.5175 9.17312 12.5165H7.60508ZM10.9517 13.2988C10.7074 13.2993 10.5095 13.4973 10.509 13.7415C10.5085 13.8594 10.5549 13.9725 10.638 14.056C10.721 14.1395 10.8339 14.1867 10.9517 14.1868H14.5756C14.6938 14.1873 14.8074 14.1405 14.8909 14.057C14.9746 13.9733 15.0214 13.8598 15.0209 13.7415C15.0206 13.6238 14.9736 13.511 14.8901 13.4279C14.8065 13.3449 14.6934 13.2985 14.5756 13.2988L10.9517 13.2988ZM8.04693 13.4002H8.72785V14.082H8.04693V13.4002Z"
          fill="black"
        />
      </svg>
    ),
  },

  {
    name: 'legal_forms',
    label: 'Legal Forms',
    category: 'trademark',
    description:
      'All forms, contracts and agreements that you need to manage and grow your business.',
    price: 19,
    per: 'month',
    monthlyValue: ({ count }) => count * 19,
    yearlyValue: ({ count }) => count * 19 * 12,
    priceType: 'direct',
    icon: () => (
      <svg
        width="23"
        height="23"
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.80369 1.50825C5.6855 1.50788 5.57189 1.55466 5.48835 1.6382C5.40469 1.72186 5.35791 1.83535 5.3584 1.95354V16.1474C5.35865 16.2652 5.40568 16.3781 5.48922 16.4611C5.57275 16.5442 5.68587 16.5906 5.80369 16.5901H16.3762C16.6202 16.5892 16.8176 16.3915 16.818 16.1474V5.58785C16.8225 5.52808 16.8148 5.46793 16.7955 5.41112C16.7935 5.40531 16.7916 5.39961 16.7894 5.39392C16.7872 5.38835 16.7849 5.38291 16.7825 5.37746C16.78 5.37189 16.7774 5.36645 16.7747 5.361C16.7694 5.34974 16.7636 5.33885 16.7574 5.32808V5.32721C16.7543 5.32189 16.7511 5.31669 16.7479 5.31162C16.7444 5.30692 16.7409 5.30221 16.7375 5.29763C16.7362 5.2959 16.7351 5.29417 16.7339 5.29244C16.7317 5.28922 16.7293 5.28612 16.7269 5.28291C16.725 5.28031 16.723 5.27771 16.7209 5.27511C16.7189 5.27276 16.7169 5.27041 16.7148 5.26818C16.7071 5.2589 16.699 5.24999 16.6906 5.24132L13.0892 1.639C13.0652 1.61622 13.0388 1.59617 13.0104 1.57922C13.0011 1.57316 12.9915 1.56734 12.9818 1.56189C12.955 1.54754 12.9268 1.5359 12.8977 1.52724C12.8855 1.52415 12.873 1.52155 12.8605 1.51944C12.8417 1.51548 12.8225 1.51288 12.8033 1.51152C12.7938 1.51004 12.7842 1.50892 12.7747 1.50806L5.80369 1.50825ZM6.24551 2.39537H12.3299V5.55572C12.3309 5.80077 12.5302 5.99855 12.7752 5.99753H15.9312V15.702H6.24576L6.24551 2.39537ZM13.217 3.02173L14.2583 4.06305L15.3031 5.11045H13.217V3.02173ZM7.60502 6.30153C7.48719 6.30116 7.37408 6.34757 7.29054 6.43061C7.207 6.51366 7.15997 6.62652 7.15972 6.74422V8.31226C7.15923 8.43058 7.20601 8.54406 7.28967 8.62773C7.37321 8.71126 7.48683 8.75805 7.60502 8.75755H9.17306C9.41798 8.75669 9.61576 8.55731 9.61487 8.31225V6.74421C9.61438 6.50028 9.41698 6.30252 9.17306 6.30151L7.60502 6.30153ZM10.9517 7.08469C10.8338 7.08494 10.721 7.1321 10.6379 7.21563C10.5549 7.29917 10.5085 7.41229 10.509 7.52999C10.51 7.77404 10.7077 7.97145 10.9517 7.9718H14.5755C14.6931 7.9723 14.8062 7.92601 14.8897 7.84321C14.9732 7.76029 15.0203 7.64767 15.0208 7.52998C15.0213 7.41178 14.9746 7.2983 14.8909 7.21464C14.8073 7.1311 14.6937 7.08432 14.5755 7.08469L10.9517 7.08469ZM8.04686 7.18952H8.72779V7.87045H8.04686V7.18952ZM7.60505 9.40905C7.36012 9.40819 7.16076 9.60596 7.15975 9.85087V11.4198C7.16074 11.6648 7.36011 11.8626 7.60505 11.8616H9.17309C9.41665 11.8607 9.61392 11.6635 9.6149 11.4198V9.85087C9.61391 9.60731 9.41664 9.41004 9.17309 9.40905H7.60505ZM10.9517 10.1913C10.8337 10.1916 10.7208 10.2389 10.6377 10.3225C10.5547 10.4063 10.5083 10.5195 10.509 10.6375C10.51 10.8815 10.7078 11.079 10.9517 11.0793H14.5756C14.6931 11.0798 14.8063 11.0335 14.8897 10.9507C14.9732 10.8678 15.0204 10.7552 15.0209 10.6375C15.0216 10.5192 14.9748 10.4054 14.8913 10.3216C14.8076 10.2379 14.694 10.1909 14.5756 10.1913L10.9517 10.1913ZM8.04689 10.2962H8.72782V10.978H8.04689V10.2962ZM7.60508 12.5165C7.36016 12.5157 7.16079 12.7134 7.15978 12.9584V14.5273C7.16077 14.7723 7.36015 14.9701 7.60508 14.9691H9.17312C9.41668 14.9682 9.61395 14.771 9.61494 14.5273V12.9584C9.61395 12.7148 9.41667 12.5175 9.17312 12.5165H7.60508ZM10.9517 13.2988C10.7074 13.2993 10.5095 13.4973 10.509 13.7415C10.5085 13.8594 10.5549 13.9725 10.638 14.056C10.721 14.1395 10.8339 14.1867 10.9517 14.1868H14.5756C14.6938 14.1873 14.8074 14.1405 14.8909 14.057C14.9746 13.9733 15.0214 13.8598 15.0209 13.7415C15.0206 13.6238 14.9736 13.511 14.8901 13.4279C14.8065 13.3449 14.6934 13.2985 14.5756 13.2988L10.9517 13.2988ZM8.04693 13.4002H8.72785V14.082H8.04693V13.4002Z"
          fill="black"
        />
      </svg>
    ),
  },
  {
    name: 'domain',
    label: 'Domain',
    category: 'trademark',
    description:
      'Choose domain (.com, .net, .biz etc.) with a 10% discount coupon.',
    price: 0,
    priceType: 'direct',
    icon: () => (
      <svg
        width="23"
        height="23"
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.0886 3.55927C6.7405 3.55927 3.20312 7.09664 3.20312 11.4448C3.20312 15.7929 6.7405 19.3303 11.0886 19.3303C15.4368 19.3303 18.9742 15.7929 18.9742 11.4448C18.9742 7.09664 15.4368 3.55927 11.0886 3.55927V3.55927ZM17.9708 10.9521H14.5066C14.477 9.81699 14.3461 8.72678 14.1242 7.74614C14.8586 7.47312 15.5116 7.10048 16.0394 6.64393C17.138 7.77646 17.8523 9.28313 17.9709 10.9521L17.9708 10.9521ZM8.55972 16.8052C8.76059 17.3073 8.98795 17.7376 9.23631 18.0919C8.37086 17.8505 7.57347 17.4439 6.88029 16.9089C7.28152 16.5817 7.76579 16.3081 8.30873 16.0976C8.38584 16.3437 8.46962 16.5801 8.55972 16.8052H8.55972ZM13.8685 16.0975C14.4114 16.308 14.8958 16.5813 15.2969 16.9088C14.6037 17.444 13.8064 17.8503 12.9409 18.0918C13.1893 17.7376 13.4167 17.3071 13.6175 16.8051C13.7077 16.5801 13.7915 16.3437 13.8685 16.0975H13.8685ZM12.7024 16.439C12.2414 17.5915 11.6381 18.2795 11.0887 18.2795C10.5393 18.2795 9.93596 17.5915 9.47494 16.4391C9.39475 16.2388 9.32024 16.0282 9.25118 15.809C9.82977 15.675 10.4498 15.6039 11.0887 15.6039C11.7278 15.6039 12.3478 15.6749 12.9261 15.809C12.8572 16.0281 12.7824 16.2386 12.7024 16.439H12.7024ZM11.0887 14.6182C10.3652 14.6182 9.66022 14.7012 8.99885 14.8579C8.80207 13.9667 8.68499 12.9747 8.65677 11.9378H13.5207C13.4925 12.9748 13.3754 13.9667 13.1786 14.8579C12.5172 14.7011 11.8123 14.6182 11.0888 14.6182H11.0887ZM8.65677 10.9522C8.68499 9.9152 8.80206 8.92325 8.99885 8.03204C9.66022 8.18872 10.3652 8.27177 11.0887 8.27177C11.8122 8.27177 12.5171 8.18872 13.1785 8.03204C13.3753 8.92325 13.4924 9.9153 13.5206 10.9522H8.65677ZM13.6177 6.08476C13.4168 5.58265 13.1894 5.15234 12.9411 4.79803C13.8065 5.03949 14.6039 5.44604 15.2971 5.98106C14.8959 6.30828 14.4116 6.5818 13.8686 6.7923C13.7915 6.54614 13.7078 6.30977 13.6177 6.08476H13.6177ZM8.30889 6.7923C7.76595 6.58178 7.28155 6.3085 6.88044 5.98106C7.57363 5.44578 8.37102 5.03948 9.23647 4.79803C8.98808 5.15224 8.76072 5.58268 8.55988 6.08476C8.46966 6.30976 8.38587 6.54612 8.3089 6.7923H8.30889ZM9.47498 6.45085C9.93612 5.29839 10.5393 4.6104 11.0887 4.6104C11.6381 4.6104 12.2414 5.29839 12.7024 6.45085C12.7826 6.6511 12.8571 6.86175 12.9262 7.08093C12.3476 7.21496 11.7278 7.286 11.0887 7.286C10.4496 7.286 9.82958 7.21509 9.25125 7.08093C9.32018 6.86175 9.39494 6.65125 9.47501 6.45085H9.47498ZM6.13815 6.64392C6.66586 7.10034 7.31884 7.47312 8.05334 7.74613C7.83131 8.72668 7.70049 9.81701 7.67093 10.9521H4.20674C4.3253 9.28306 5.0399 7.77655 6.13828 6.64389L6.13815 6.64392ZM4.20661 11.9378H7.6708C7.70038 13.0729 7.83132 14.1631 8.05321 15.1438C7.31881 15.4168 6.66598 15.7894 6.13802 16.246C5.0399 15.1134 4.3253 13.6068 4.20674 11.9378L4.20661 11.9378ZM16.0392 16.246C15.5115 15.7896 14.8585 15.4168 14.124 15.1438C14.346 14.1632 14.4768 13.0729 14.5064 11.9378H17.9706C17.852 13.607 17.1377 15.1137 16.039 16.246L16.0392 16.246Z"
          fill="black"
        />
      </svg>
    ),
  },
  {
    name: 'patent',
    label: 'PE Design Patent',
    category: 'trademark',
    description:
      "Protect your product's designs and shape with a design patent.",
    price: 899,
    priceType: 'direct',
    icon: () => (
      <svg
        width="23"
        height="23"
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.01206 7.77966C10.5542 7.77966 12.6196 9.8429 12.6196 12.3872C12.6196 14.0881 11.6882 15.5576 10.3161 16.3558V19.7107L8.01206 18.559L5.70803 19.7107V16.356C4.33663 15.5574 3.40449 14.0879 3.40449 12.3875C3.40449 9.8429 5.46865 7.77966 8.01206 7.77966ZM8.01206 14.6913C9.28342 14.6913 10.3161 13.6586 10.3161 12.3872C10.3161 11.1137 9.28342 10.0837 8.01206 10.0837C6.74069 10.0837 5.70803 11.114 5.70803 12.3872C5.70803 13.6586 6.74069 14.6913 8.01206 14.6913Z"
          fill="#09ABAB"
        />
        <rect
          x="13.4473"
          y="12.6654"
          width="3.8567"
          height="1.25352"
          rx="0.626761"
          fill="#09ABAB"
        />
        <rect
          x="13.4473"
          y="15.1368"
          width="5.3261"
          height="1.25352"
          rx="0.626761"
          fill="#09ABAB"
        />
        <rect
          x="13.4473"
          y="10.1945"
          width="5.3261"
          height="1.25352"
          rx="0.626761"
          fill="#09ABAB"
        />
      </svg>
    ),
  },
  {
    name: 'digital_marketing',
    label: 'Digital Marketing',
    category: 'trademark',
    description:
      'Grow your brand globally with our network of over 2,000 influencers worldwide.',
    price: 150,
    per: 'month',
    priceType: 'direct',
    icon: () => (
      <svg
        width="23"
        height="23"
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.0894 5.75427C13.4388 5.75427 12.8858 6.17717 12.6893 6.76216L7.56619 8.84049H5.0598C4.03606 8.84049 3.20312 9.67339 3.20312 10.6972V11.936C3.20312 12.9597 4.03603 13.7927 5.0598 13.7927H5.34333V16.441C5.34333 17.2162 5.97401 17.847 6.74925 17.847C7.52437 17.847 8.15517 17.2163 8.15517 16.441L8.1553 14.0315L12.7335 15.8888C12.9603 16.4132 13.4826 16.781 14.0894 16.781C14.9037 16.781 15.5661 16.1184 15.5661 15.304V7.23097C15.5661 6.41688 14.9035 5.75427 14.0893 5.75427H14.0894ZM8.15552 9.66519L12.6126 7.85706V14.7759L8.15552 12.9678V9.66519ZM4.18915 11.9358V10.697C4.18915 10.2168 4.57987 9.82607 5.06005 9.82607H7.1698V12.8067L5.06005 12.8068C4.57987 12.8068 4.18915 12.4161 4.18915 11.9358V11.9358ZM6.7495 16.8609C6.51782 16.8609 6.3292 16.6724 6.3292 16.4406V13.7925H7.16977V16.4409C7.16977 16.6725 6.98116 16.8609 6.74947 16.8609H6.7495ZM14.5805 15.304C14.5805 15.5749 14.3601 15.7952 14.0893 15.7952C13.8184 15.7952 13.5981 15.5748 13.5981 15.304L13.598 7.23091C13.598 6.96 13.8184 6.7397 14.0892 6.7397C14.3601 6.7397 14.5803 6.96012 14.5803 7.23091L14.5805 15.304ZM18.9743 11.2676C18.9743 11.5399 18.7537 11.7604 18.4815 11.7604H17.2608C16.9885 11.7604 16.768 11.5399 16.768 11.2676C16.768 10.9953 16.9885 10.7748 17.2608 10.7748H18.4813C18.7536 10.7748 18.9743 10.9954 18.9743 11.2676ZM16.2772 9.43619C16.1411 9.20042 16.2217 8.89894 16.4575 8.76293L17.5148 8.15253C17.7505 8.01627 18.052 8.09708 18.188 8.33285C18.324 8.56861 18.2435 8.87009 18.0077 9.00611L16.9504 9.6165C16.8727 9.66131 16.7879 9.68259 16.7044 9.68259C16.5341 9.68284 16.3685 9.59435 16.2772 9.43619H16.2772ZM18.188 14.2022C18.0967 14.3603 17.9311 14.4486 17.7607 14.4486C17.6771 14.4486 17.5924 14.4273 17.5146 14.3825L16.4576 13.7721C16.2218 13.6361 16.1412 13.3346 16.2773 13.0989C16.4133 12.8631 16.7148 12.7824 16.9505 12.9186L18.0076 13.529C18.2432 13.6652 18.324 13.9663 18.188 14.2022H18.188Z"
          fill="black"
        />
      </svg>
    ),
  },
  {
    name: 'paid_ads',
    label: 'Paid Ads',
    category: 'trademark',
    description:
      "Free digital marketing consultation by Trademarkia's in-house experts.",
    price: 0,
    priceType: 'direct',
    icon: () => (
      <svg
        width="23"
        height="23"
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.0894 5.75427C13.4388 5.75427 12.8858 6.17717 12.6893 6.76216L7.56619 8.84049H5.0598C4.03606 8.84049 3.20312 9.67339 3.20312 10.6972V11.936C3.20312 12.9597 4.03603 13.7927 5.0598 13.7927H5.34333V16.441C5.34333 17.2162 5.97401 17.847 6.74925 17.847C7.52437 17.847 8.15517 17.2163 8.15517 16.441L8.1553 14.0315L12.7335 15.8888C12.9603 16.4132 13.4826 16.781 14.0894 16.781C14.9037 16.781 15.5661 16.1184 15.5661 15.304V7.23097C15.5661 6.41688 14.9035 5.75427 14.0893 5.75427H14.0894ZM8.15552 9.66519L12.6126 7.85706V14.7759L8.15552 12.9678V9.66519ZM4.18915 11.9358V10.697C4.18915 10.2168 4.57987 9.82607 5.06005 9.82607H7.1698V12.8067L5.06005 12.8068C4.57987 12.8068 4.18915 12.4161 4.18915 11.9358V11.9358ZM6.7495 16.8609C6.51782 16.8609 6.3292 16.6724 6.3292 16.4406V13.7925H7.16977V16.4409C7.16977 16.6725 6.98116 16.8609 6.74947 16.8609H6.7495ZM14.5805 15.304C14.5805 15.5749 14.3601 15.7952 14.0893 15.7952C13.8184 15.7952 13.5981 15.5748 13.5981 15.304L13.598 7.23091C13.598 6.96 13.8184 6.7397 14.0892 6.7397C14.3601 6.7397 14.5803 6.96012 14.5803 7.23091L14.5805 15.304ZM18.9743 11.2676C18.9743 11.5399 18.7537 11.7604 18.4815 11.7604H17.2608C16.9885 11.7604 16.768 11.5399 16.768 11.2676C16.768 10.9953 16.9885 10.7748 17.2608 10.7748H18.4813C18.7536 10.7748 18.9743 10.9954 18.9743 11.2676ZM16.2772 9.43619C16.1411 9.20042 16.2217 8.89894 16.4575 8.76293L17.5148 8.15253C17.7505 8.01627 18.052 8.09708 18.188 8.33285C18.324 8.56861 18.2435 8.87009 18.0077 9.00611L16.9504 9.6165C16.8727 9.66131 16.7879 9.68259 16.7044 9.68259C16.5341 9.68284 16.3685 9.59435 16.2772 9.43619H16.2772ZM18.188 14.2022C18.0967 14.3603 17.9311 14.4486 17.7607 14.4486C17.6771 14.4486 17.5924 14.4273 17.5146 14.3825L16.4576 13.7721C16.2218 13.6361 16.1412 13.3346 16.2773 13.0989C16.4133 12.8631 16.7148 12.7824 16.9505 12.9186L18.0076 13.529C18.2432 13.6652 18.324 13.9663 18.188 14.2022H18.188Z"
          fill="black"
        />
      </svg>
    ),
  },
  {
    name: 'insurance',
    label: 'Trademark Insurance',
    category: 'trademark',
    description:
      "If your first mark gets a final refusal, we'll cover our legal fee to register a different mark.",
    price: {
      plus: 99,
      gold: 199,
    },
    priceType: 'type_based',
    icon: () => (
      <svg
        width="23"
        height="24"
        viewBox="0 0 23 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.81982 18.1514L10.4294 19.6891C10.6292 19.8053 10.8562 19.8666 11.0874 19.8666C11.3185 19.8666 11.5455 19.8053 11.7453 19.6891L14.3549 18.1514C15.4497 17.505 16.3738 16.6061 17.0503 15.5296C17.7268 14.4531 18.1358 13.2305 18.2434 11.9637L18.6131 7.52814C18.6468 7.23458 18.5785 6.93856 18.4197 6.68941C18.2608 6.4404 18.021 6.25364 17.7407 6.16046C17.3403 6.04821 16.9573 5.88151 16.6022 5.66517C16.1639 5.3622 15.7726 4.996 15.4416 4.57842C15.2011 4.26753 14.8292 4.08696 14.4362 4.09057H7.7828C7.38987 4.08698 7.01782 4.26754 6.77738 4.57842C6.43964 4.99758 6.04089 5.36393 5.5946 5.66517C5.2326 5.88336 4.84201 6.05005 4.43397 6.16046C4.1591 6.25254 3.92334 6.43484 3.76492 6.67765C3.60663 6.9206 3.53498 7.20983 3.56158 7.49855L3.93126 11.9341C4.03435 13.206 4.44129 14.4346 5.118 15.5165C5.79458 16.5984 6.72121 17.502 7.81981 18.1512L7.81982 18.1514ZM4.79621 7.21765C5.3019 7.07434 5.78468 6.86037 6.23036 6.58191C6.75845 6.2116 7.2291 5.7657 7.62764 5.25865C7.66018 5.21904 7.70944 5.19714 7.76068 5.19949H14.4141C14.4653 5.19714 14.5145 5.21904 14.5471 5.25865C14.9456 5.7657 15.4163 6.2116 15.9444 6.58191C16.39 6.86037 16.8728 7.07435 17.3785 7.21765C17.4629 7.24191 17.5185 7.32236 17.5116 7.40985L17.1346 11.8454C17.0498 12.9436 16.7012 14.0051 16.1182 14.9394C15.535 15.874 14.7349 16.6536 13.7858 17.2124L11.1836 18.7501C11.1228 18.7794 11.052 18.7794 10.9912 18.7501L8.38904 17.2124C7.44474 16.6573 6.6476 15.8832 6.06483 14.9557C5.48203 14.0281 5.1307 12.9741 5.04021 11.8824L4.66325 7.44686C4.64976 7.39872 4.65632 7.34723 4.68132 7.30416C4.70644 7.26097 4.7479 7.22978 4.79629 7.21765H4.79621Z"
          fill="black"
        />
        <path
          d="M10.1409 13.5164C10.2448 13.6203 10.3858 13.6786 10.5327 13.6786C10.6796 13.6786 10.8205 13.6203 10.9245 13.5164L13.8815 10.5594V10.5593C13.9639 10.4144 13.9768 10.2399 13.9163 10.0844C13.8559 9.92899 13.7287 9.80894 13.57 9.75772C13.4112 9.70648 13.2378 9.72938 13.0979 9.8201L10.5327 12.3853L9.44592 11.2987C9.30595 11.2078 9.13256 11.1849 8.97391 11.2363C8.81513 11.2875 8.68803 11.4076 8.62749 11.563C8.5671 11.7184 8.57984 11.8928 8.66227 12.0379L10.1409 13.5164Z"
          fill="black"
        />
      </svg>
    ),
  },
  {
    name: 'privacy_guard',
    label: 'Privacy Guard Service',
    category: 'trademark',
    description:
      'Hides your personal data like name, address, phone number and email.',
    price: {
      plus: 60,
      gold: 39,
    },
    per: {
      plus: 'year',
      gold: 'month',
    },
    monthlyValue: ({ count, type }) => {
      if (type === 'plus') {
        return 5 * count // 5 === 60/12
      }
      return 39 * count
    },
    yearlyValue: ({ count, type }) => {
      if (type === 'plus') {
        return 60 * count
      }
      return 39 * count * 12
    },
    priceType: 'type_based',
    icon: () => (
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.17754 8.95745V6.14199C7.17754 4.16187 8.92834 2.55664 11.089 2.55664C13.2493 2.55664 15.0005 4.16339 15.0005 6.14199V8.95745H15.7941C16.5341 8.95745 17.1341 9.5954 17.1341 10.3787V17.493C17.1341 18.278 16.5346 18.9143 15.7941 18.9143H6.38399C5.64391 18.9143 5.04395 18.2763 5.04395 17.493V10.3787C5.04395 9.59372 5.64342 8.95745 6.38399 8.95745H7.17754ZM6.46626 10.3798V17.492H15.712V10.3798H6.46626ZM13.5784 8.95745V6.14199C13.5784 4.97732 12.4896 3.97899 11.0892 3.97899C9.68783 3.97899 8.59998 4.97626 8.59998 6.14199V8.95745H13.5784ZM10.3781 13.0713C10.3781 12.6787 10.6937 12.3603 11.0892 12.3603C11.482 12.3603 11.8004 12.6758 11.8004 13.0713V15.2052C11.8004 15.598 11.4847 15.9162 11.0892 15.9162C10.6964 15.9162 10.3781 15.6007 10.3781 15.2052V13.0713Z"
          fill="black"
        />
      </svg>
    ),
  },
  {
    name: 'priority',
    label: 'Rush Priority Service',
    category: 'trademark',
    description: 'Get your application processed faster.',
    price: {
      basic: 0,
      plus: 49,
      gold: 89,
    },
    priceType: 'type_based',
    icon: () => (
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.17754 8.95745V6.14199C7.17754 4.16187 8.92834 2.55664 11.089 2.55664C13.2493 2.55664 15.0005 4.16339 15.0005 6.14199V8.95745H15.7941C16.5341 8.95745 17.1341 9.5954 17.1341 10.3787V17.493C17.1341 18.278 16.5346 18.9143 15.7941 18.9143H6.38399C5.64391 18.9143 5.04395 18.2763 5.04395 17.493V10.3787C5.04395 9.59372 5.64342 8.95745 6.38399 8.95745H7.17754ZM6.46626 10.3798V17.492H15.712V10.3798H6.46626ZM13.5784 8.95745V6.14199C13.5784 4.97732 12.4896 3.97899 11.0892 3.97899C9.68783 3.97899 8.59998 4.97626 8.59998 6.14199V8.95745H13.5784ZM10.3781 13.0713C10.3781 12.6787 10.6937 12.3603 11.0892 12.3603C11.482 12.3603 11.8004 12.6758 11.8004 13.0713V15.2052C11.8004 15.598 11.4847 15.9162 11.0892 15.9162C10.6964 15.9162 10.3781 15.6007 10.3781 15.2052V13.0713Z"
          fill="black"
        />
      </svg>
    ),
  },
  {
    name: 'app_dev',
    label: 'App Dev',
    category: 'trademark',
    description: 'We help you create the perfect website or mobile app.',
    price: 0,
    priceType: 'direct',
    icon: () => (
      <svg
        width="23"
        height="23"
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.7774 10.3094V15.0409H6.68047V5.57854H10.2289V4.39563H6.68047C6.02999 4.39563 5.49756 4.92806 5.49756 5.57854V17.407C5.49756 18.0572 6.02999 18.5896 6.68047 18.5896H13.7774C14.4276 18.5896 14.9601 18.0572 14.9601 17.4067V10.3098L13.7774 10.3094ZM10.8203 17.4063H9.63735C9.31051 17.4063 9.04602 17.142 9.04602 16.815C9.04602 16.488 9.3105 16.2237 9.63735 16.2237H10.8203C11.1472 16.2237 11.4116 16.488 11.4116 16.815C11.4116 17.142 11.1472 17.4063 10.8203 17.4063Z"
          fill="black"
        />
        <path
          d="M19.5175 6.34282L17.8655 4.69098L17.2383 5.31893L18.6816 6.761L17.2389 8.20367L17.8661 8.83077L19.518 7.17893C19.7488 6.94799 19.7488 6.573 19.5175 6.34279L19.5175 6.34282Z"
          fill="black"
        />
        <path
          d="M13.8649 5.3182L13.2377 4.69098L11.5854 6.34282C11.3543 6.57388 11.3543 6.94926 11.5854 7.17909L13.2377 8.8308L13.8649 8.20358L12.4216 6.76091L13.8649 5.3182Z"
          fill="black"
        />
        <path
          d="M15.4005 4.39532H16.2941L15.7031 9.12682H14.8091L15.4005 4.39532Z"
          fill="black"
        />
      </svg>
    ),
  },
  {
    name: 'incd_business',
    label: 'Incd Business',
    category: 'trademark',
    description: 'Launch your business (LLC/C-Corp/S-Corp) using Trademarkia.',
    price: 99,
    priceType: 'direct',
    icon: () => (
      <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.333008"
          y="0.58136"
          width="15.5117"
          height="15.5117"
          rx="4.43192"
          fill="#E92169"
        />
        <rect
          x="0.333008"
          y="0.58136"
          width="15.5117"
          height="15.5117"
          rx="4.43192"
          fill="#E92169"
        />
        <path
          d="M8.69727 5.08209L6.93652 6.34045V8.35646H8.7851L8.69727 5.08209Z"
          fill="url(#paint0_linear_1050_11176)"
        />
        <path
          d="M6.92516 8.9772L6.92715 6.41019C6.92719 6.35374 6.9883 6.31848 7.03719 6.34668L9.16294 7.57283C9.21981 7.60564 9.25481 7.66633 9.25473 7.73198L9.2515 10.3016C9.25143 10.358 9.19027 10.3933 9.14138 10.365L7.01677 9.13614C6.96003 9.10333 6.92511 9.04274 6.92516 8.9772Z"
          fill="#FFEBF2"
        />
        <path
          d="M10.4322 7.18482L10.4305 7.08706L10.3484 7.03395L7.81038 5.39237L10.0045 4.08346L12.7879 5.66972L12.7331 8.67151L10.4808 9.9915L10.4322 7.18482Z"
          fill="#FFEBF2"
          stroke="#E92169"
          strokeWidth="0.366908"
        />
        <path
          d="M5.74605 9.48907L5.74774 9.58683L5.82984 9.63993L8.11995 11.1212C8.23413 11.195 8.23109 11.3631 8.1143 11.4328L6.17372 12.5904L3.39035 11.0042L3.44507 8.00238L5.42671 6.84106C5.54779 6.7701 5.70046 6.85584 5.70289 6.99616L5.74605 9.48907Z"
          fill="#FFEBF2"
          stroke="#E92169"
          strokeWidth="0.366908"
        />
        <path
          d="M10.4322 7.18482L10.4305 7.08706L10.3484 7.03395L7.81038 5.39237L10.0045 4.08346L12.7879 5.66972L12.7331 8.67151L10.4808 9.9915L10.4322 7.18482Z"
          fill="#FFEBF2"
          stroke="#E92169"
          strokeWidth="0.366908"
        />
        <path
          d="M5.74605 9.48907L5.74774 9.58683L5.82984 9.63993L8.11995 11.1212C8.23413 11.195 8.23109 11.3631 8.1143 11.4328L6.17372 12.5904L3.39035 11.0042L3.44507 8.00238L5.42671 6.84106C5.54779 6.7701 5.70046 6.85584 5.70289 6.99616L5.74605 9.48907Z"
          fill="#FFEBF2"
          stroke="#E92169"
          strokeWidth="0.366908"
        />
        <path
          d="M5.50627 6.92038L5.56201 9.63229L3.56828 10.8425L3.61458 8.05785L5.50627 6.92038Z"
          fill="#FCDBE7"
        />
        <path
          d="M10.6597 9.73159L10.604 7.01969L12.5977 5.80945L12.5514 8.59413L10.6597 9.73159Z"
          fill="#FFD3E3"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1050_11176"
            x1="6.96492"
            y1="7.47621"
            x2="7.95872"
            y2="7.41942"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F35991" />
            <stop offset="1" stopColor="#F35991" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  {
    name: 'attorney_consultation',
    label: 'Attorney Consultation',
    category: 'trademark',
    description:
      'Get a consultation with professional trademark attorneys at Trademarkia.',
    price: {
      basic: 0,
      plus: 99,
      gold: 199,
    },
    priceType: 'type_based',
    icon: () => (
      <svg
        width="20"
        height="19"
        viewBox="0 0 20 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.6522 12.1957L13.4724 11.0717L12.2754 10.4487L11.9495 10.278V9.20507C12.6833 8.50018 13.0822 7.64004 13.0889 6.73559H13.0911C13.1045 6.59149 13.1111 6.46288 13.1111 6.34317C13.4123 5.06788 13.5928 3.59362 12.2953 3.2929C12.1191 2.02127 9.41403 1.8637 8.7418 2.53695L7.98585 3.18868C7.57355 3.31064 7.26983 3.53669 7.08143 3.86481C6.77995 4.38794 6.77332 5.16829 7.05928 6.24345V6.71116C7.05928 7.63999 7.47158 8.52226 8.23202 9.24053V10.2359L6.66699 11.1049L7.516 12.2089C7.56917 12.2776 7.57581 12.3685 7.53815 12.446L7.04603 13.3992L8.84834 16.3299H11.4021L13.1068 13.3972L12.6324 12.4218C12.5945 12.3486 12.6034 12.2599 12.6522 12.1957L12.6522 12.1957ZM10.0918 15.3235L8.66633 10.4799C8.68429 10.4173 8.67061 10.4908 8.67521 9.60876C8.83064 9.7198 9.9059 10.4319 10.1915 10.3248C10.3933 10.2575 11.0092 9.9542 11.506 9.58211C11.5129 10.4988 11.4932 10.4145 11.5193 10.4932L10.0918 15.3235ZM10.074 9.89469C9.77703 9.7165 7.79394 9.00119 7.52913 7.0772C7.58454 7.11935 7.65996 7.13262 7.73089 7.10823C7.83285 7.07496 7.8949 6.973 7.87939 6.86656C7.82397 6.48302 7.87275 6.19706 8.02349 6.0153C8.18086 5.82242 8.46908 5.71822 8.90354 5.69606C8.94558 5.69382 8.98998 5.6783 9.02325 5.65177C9.07866 5.61187 9.12306 5.58084 9.15847 5.55869C9.14959 5.59635 9.13857 5.64289 9.12081 5.70055C9.10081 5.76709 9.11194 5.84017 9.15408 5.89558C9.19623 5.95324 9.26053 5.98652 9.33146 5.98652L9.35136 5.98662C10.2824 5.98662 10.9807 5.5543 11.4285 4.69866C12.169 4.78959 12.6234 5.346 12.6633 6.21941C12.6522 6.24604 12.6478 6.27258 12.6478 6.30146V6.71151C12.6477 8.18798 11.4681 9.29519 10.074 9.89477L10.074 9.89469Z"
          fill="black"
        />
        <path
          d="M6.60343 13.525C6.56271 13.459 6.55965 13.3765 6.59496 13.3075L7.0782 12.3682L6.27277 11.3215L5.16127 11.9118C4.2147 12.3996 3.625 13.3616 3.625 14.4257V16.1082C3.625 16.2302 3.72471 16.3299 3.84667 16.3299H5.33282V14.6031H5.77616V16.3299H8.32677L6.60343 13.525Z"
          fill="black"
        />
        <path
          d="M13.8688 11.2799L13.0885 12.3484L13.5562 13.3083C13.5894 13.3748 13.585 13.4546 13.5495 13.5189L11.9136 16.3299H14.4011V14.6031H14.8444V16.3299H16.3317C16.4536 16.3299 16.5534 16.2302 16.5534 16.1082V14.3902C16.5534 12.121 14.2802 11.5972 13.8689 11.2801L13.8688 11.2799Z"
          fill="black"
        />
      </svg>
    ),
  },
  {
    name: 'monitoring',
    label: 'Trademark Monitoring',
    category: 'trademark',
    description:
      'Protect your mark from infringement by watching for competing marks.',
    price: 99,
    per: 'quarter',
    priceType: 'direct',
    monthlyValue: ({ count, freeTrialCount }) =>
      (99 / 3) * (count - (freeTrialCount ?? 0)) +
      (99 / 3) * (freeTrialCount ?? 0),
    yearlyValue: ({ count, freeTrialCount }) =>
      (99 / 3) * 12 * (count - (freeTrialCount ?? 0)) +
      (99 / 3) * 11 * (freeTrialCount ?? 0),
    icon: () => (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.5298 11.7174H3.64842V2.36078H16.5298V11.7174ZM11.7721 13.9421H8.40611L9.1586 12.6378L11.0188 12.6379L11.7721 13.9421ZM16.5862 1.4411H3.5907C3.36187 1.44153 3.14248 1.5327 2.98065 1.69453C2.81892 1.85637 2.72786 2.07576 2.72754 2.30458V11.7739C2.72786 12.0028 2.81892 12.2222 2.98076 12.3841C3.14259 12.546 3.36198 12.6372 3.59081 12.6376H8.09542L7.20948 14.172C7.15539 14.2657 7.1361 14.3755 7.15507 14.4822C7.17393 14.5888 7.22986 14.6852 7.31289 14.7547C7.39592 14.8242 7.50085 14.8621 7.60904 14.8619H12.5687C12.7331 14.8619 12.885 14.7742 12.9671 14.632C13.0494 14.4897 13.0495 14.3143 12.9673 14.172L12.0815 12.6376H16.5861C16.815 12.6372 17.0344 12.546 17.1963 12.3841C17.3581 12.2222 17.4491 12.0028 17.4495 11.7739V2.30459C17.4491 2.07577 17.3581 1.85638 17.1963 1.69443C17.0344 1.5326 16.815 1.44154 16.5861 1.44111L16.5862 1.4411Z"
          fill="black"
        />
      </svg>
    ),
  },
  {
    name: 'search',
    label: 'Advanced Search Service',
    category: 'trademark',
    description:
      'We provide a comprehensive search of all marks, both registered and un-registered.',
    icon: () => (
      <svg
        width="14"
        height="15"
        viewBox="0 0 14 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.22508 12.5244C8.05549 12.3794 8.84483 12.0574 9.53957 11.58L12.2005 14.2284C12.4494 14.4766 12.8121 14.573 13.1514 14.4814C13.4909 14.3898 13.7556 14.124 13.846 13.7842C13.9364 13.4446 13.8386 13.0823 13.5895 12.8342L10.9557 10.211C12.0489 8.72672 12.3859 6.81683 11.8669 5.04789C11.3478 3.2789 10.0324 1.85411 8.31026 1.19578C6.58838 0.537416 4.65778 0.721213 3.09121 1.69276C1.52456 2.66432 0.501488 4.31186 0.325806 6.14701C0.149877 7.98203 0.84142 9.79401 2.19516 11.0452C3.54889 12.2965 5.4093 12.8438 7.22508 12.5244ZM5.52941 2.83242C6.5577 2.65251 7.61517 2.88834 8.46945 3.48822C9.3236 4.08815 9.9046 5.00271 10.0845 6.03079C10.2644 7.05909 10.0284 8.11659 9.42867 8.97083C8.82874 9.82499 7.91418 10.406 6.88593 10.5859C5.8578 10.7658 4.80031 10.5298 3.94606 9.93005C3.09174 9.33016 2.51091 8.41557 2.33101 7.38731C2.15113 6.35919 2.38696 5.30172 2.98684 4.44744C3.58674 3.59312 4.50133 3.01229 5.52941 2.83242Z"
          fill="black"
        />
      </svg>
    ),
    price: 299,
    per: 'mark',
    priceType: 'direct',
  },
  {
    name: 'international_tm_reg',
    label: 'International TM Registration',
    category: 'trademark',
    description:
      'File your Trademark in China, India, Canada, UK, and Mexico.',
    price: 1999,
    priceType: 'direct',
    icon: () => (
      <svg
        width="23"
        height="23"
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.0886 3.71875C6.7405 3.71875 3.20312 7.25613 3.20312 11.6043C3.20312 15.9524 6.7405 19.4898 11.0886 19.4898C15.4368 19.4898 18.9742 15.9524 18.9742 11.6043C18.9742 7.25613 15.4368 3.71875 11.0886 3.71875ZM17.9708 11.1116H14.5066C14.477 9.97647 14.3461 8.88627 14.1242 7.90562C14.8586 7.63261 15.5116 7.25996 16.0394 6.80341C17.138 7.93594 17.8523 9.44262 17.9709 11.1116L17.9708 11.1116ZM8.55972 16.9647C8.76059 17.4668 8.98795 17.8971 9.23631 18.2514C8.37086 18.0099 7.57347 17.6034 6.88029 17.0684C7.28152 16.7411 7.76579 16.4676 8.30873 16.2571C8.38584 16.5032 8.46962 16.7396 8.55972 16.9647H8.55972ZM13.8685 16.257C14.4114 16.4675 14.8958 16.7408 15.2969 17.0682C14.6037 17.6035 13.8064 18.0098 12.9409 18.2513C13.1893 17.8971 13.4167 17.4666 13.6175 16.9645C13.7077 16.7395 13.7915 16.5032 13.8685 16.257H13.8685ZM12.7024 16.5984C12.2414 17.751 11.6381 18.439 11.0887 18.439C10.5393 18.439 9.93596 17.751 9.47494 16.5986C9.39475 16.3983 9.32024 16.1877 9.25118 15.9685C9.82977 15.8345 10.4498 15.7634 11.0887 15.7634C11.7278 15.7634 12.3478 15.8343 12.9261 15.9685C12.8572 16.1876 12.7824 16.3981 12.7024 16.5984H12.7024ZM11.0887 14.7777C10.3652 14.7777 9.66022 14.8607 8.99885 15.0174C8.80207 14.1262 8.68499 13.1341 8.65677 12.0973H13.5207C13.4925 13.1342 13.3754 14.1262 13.1786 15.0174C12.5172 14.8606 11.8123 14.7777 11.0888 14.7777H11.0887ZM8.65677 11.1117C8.68499 10.0747 8.80206 9.08273 8.99885 8.19153C9.66022 8.34821 10.3652 8.43125 11.0887 8.43125C11.8122 8.43125 12.5171 8.34821 13.1785 8.19153C13.3753 9.08273 13.4924 10.0748 13.5206 11.1117H8.65677ZM13.6177 6.24424C13.4168 5.74214 13.1894 5.31182 12.9411 4.95751C13.8065 5.19897 14.6039 5.60552 15.2971 6.14055C14.8959 6.46777 14.4116 6.74128 13.8686 6.95178C13.7915 6.70562 13.7078 6.46925 13.6177 6.24424H13.6177ZM8.30889 6.95178C7.76595 6.74127 7.28155 6.46799 6.88044 6.14055C7.57363 5.60527 8.37102 5.19897 9.23647 4.95751C8.98808 5.31173 8.76072 5.74217 8.55988 6.24424C8.46966 6.46924 8.38587 6.70561 8.3089 6.95178H8.30889ZM9.47498 6.61034C9.93612 5.45788 10.5393 4.76989 11.0887 4.76989C11.6381 4.76989 12.2414 5.45788 12.7024 6.61034C12.7826 6.81058 12.8571 7.02123 12.9262 7.24041C12.3476 7.37445 11.7278 7.44549 11.0887 7.44549C10.4496 7.44549 9.82958 7.37457 9.25125 7.24041C9.32018 7.02123 9.39494 6.81073 9.47501 6.61034H9.47498ZM6.13815 6.80341C6.66586 7.25983 7.31884 7.63261 8.05334 7.90562C7.83131 8.88617 7.70049 9.9765 7.67093 11.1116H4.20674C4.3253 9.44255 5.0399 7.93603 6.13828 6.80337L6.13815 6.80341ZM4.20661 12.0973H7.6708C7.70038 13.2324 7.83132 14.3226 8.05321 15.3032C7.31881 15.5763 6.66598 15.9489 6.13802 16.4055C5.0399 15.2729 4.3253 13.7663 4.20674 12.0972L4.20661 12.0973ZM16.0392 16.4055C15.5115 15.9491 14.8585 15.5763 14.124 15.3033C14.346 14.3227 14.4768 13.2324 14.5064 12.0973H17.9706C17.852 13.7665 17.1377 15.2732 16.039 16.4055L16.0392 16.4055Z"
          fill="black"
        />
      </svg>
    ),
  },
  {
    name: 'logo_design',
    label: 'Logo Design',
    category: 'trademark',
    description:
      'We help you create an exclusive logo and brand identity kit which represents your business.',
    price: 599,
    priceType: 'direct',
    icon: () => (
      <svg
        width="17"
        height="14"
        viewBox="0 0 17 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.1425 10.2179L13.3006 9.22896V2.52644H14.032C14.2062 2.52644 14.3672 2.43347 14.4542 2.28265C14.5413 2.13183 14.5413 1.9459 14.4542 1.79508C14.3672 1.64427 14.2062 1.5513 14.032 1.5513H13.3006V0.819951C13.3006 0.645804 13.2077 0.48487 13.0568 0.397748C12.906 0.310614 12.7201 0.310614 12.5693 0.397748C12.4185 0.484883 12.3255 0.645816 12.3255 0.819951V1.5513H3.06171V0.819951C3.06171 0.645804 2.96875 0.48487 2.81793 0.397748C2.66711 0.310614 2.48117 0.310614 2.33036 0.397748C2.17955 0.484883 2.08658 0.645816 2.08658 0.819951V1.5513H1.35523C1.18108 1.5513 1.02015 1.64427 0.933027 1.79508C0.845892 1.9459 0.845892 2.13184 0.933027 2.28265C1.02016 2.43347 1.18109 2.52644 1.35523 2.52644H2.08658V11.7902H1.35523C1.18108 11.7902 1.02015 11.8832 0.933027 12.034C0.845892 12.1848 0.845892 12.3707 0.933027 12.5216C1.02016 12.6724 1.18109 12.7653 1.35523 12.7653H2.08658V13.4967C2.08658 13.671 2.17955 13.8319 2.33036 13.9189C2.48118 14.006 2.66712 14.006 2.81793 13.9189C2.96875 13.8319 3.06171 13.6709 3.06171 13.4967V12.7653H9.76424L10.7532 15.6072C10.8 15.7343 10.8971 15.8366 11.0217 15.8895C11.1465 15.9425 11.2874 15.9416 11.4113 15.8869C11.5353 15.8323 11.6312 15.7288 11.6762 15.6011L12.7913 12.2561L16.1363 11.1411C16.264 11.0961 16.3675 11.0002 16.422 10.8762C16.4766 10.7523 16.4775 10.6113 16.4245 10.4866C16.3715 10.362 16.2694 10.2649 16.1423 10.2181L16.1425 10.2179ZM7.69354 11.7901H3.06165V2.52634H12.3254V8.8897L11.1907 8.49486L12.1826 7.50306V7.50294C12.2734 7.41117 12.3242 7.28737 12.3242 7.15823C12.3242 7.0292 12.2734 6.90528 12.1826 6.81352L8.03828 2.6692C7.94686 2.57778 7.82283 2.52636 7.69357 2.52636C7.5643 2.52636 7.44026 2.57778 7.34886 2.6692L3.20454 6.81352C3.11312 6.90494 3.0617 7.02898 3.0617 7.15823C3.0617 7.28751 3.11312 7.41154 3.20454 7.50294L7.34886 11.6473C7.44028 11.7388 7.56431 11.7901 7.69357 11.7901C7.82284 11.7901 7.94688 11.7388 8.03828 11.6473L9.0302 10.6555L9.42504 11.7901L7.69354 11.7901ZM8.8289 7.67292C8.71308 7.63435 8.58702 7.64042 8.47535 7.68982C8.3637 7.73922 8.27454 7.82838 8.22514 7.94003C8.17574 8.05169 8.16967 8.17774 8.20824 8.29358L8.67414 9.6325L7.69352 10.613L4.2385 7.15828L7.69352 3.70356L11.1485 7.15828L10.1679 8.1389L8.8289 7.67292ZM12.2516 11.408C12.106 11.4567 11.9919 11.5708 11.9433 11.7164L11.2037 13.935L9.46051 8.92523L14.4703 10.6685L12.2516 11.408Z"
          fill="black"
        />
      </svg>
    ),
  },
  {
    name: 'border_protection',
    label: 'Border Protection',
    category: 'renewal',
    description:
      'By registering your U.S. registered trademark with the United States Bureau of Customs and Border Protection (CBP), United States Customs officials will seize goods bearing your trademark that are being illegally imported.',
    price: 499,
    priceType: 'direct',
    icon: () => (
      <svg
        width="17"
        height="14"
        viewBox="0 0 17 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.1425 10.2179L13.3006 9.22896V2.52644H14.032C14.2062 2.52644 14.3672 2.43347 14.4542 2.28265C14.5413 2.13183 14.5413 1.9459 14.4542 1.79508C14.3672 1.64427 14.2062 1.5513 14.032 1.5513H13.3006V0.819951C13.3006 0.645804 13.2077 0.48487 13.0568 0.397748C12.906 0.310614 12.7201 0.310614 12.5693 0.397748C12.4185 0.484883 12.3255 0.645816 12.3255 0.819951V1.5513H3.06171V0.819951C3.06171 0.645804 2.96875 0.48487 2.81793 0.397748C2.66711 0.310614 2.48117 0.310614 2.33036 0.397748C2.17955 0.484883 2.08658 0.645816 2.08658 0.819951V1.5513H1.35523C1.18108 1.5513 1.02015 1.64427 0.933027 1.79508C0.845892 1.9459 0.845892 2.13184 0.933027 2.28265C1.02016 2.43347 1.18109 2.52644 1.35523 2.52644H2.08658V11.7902H1.35523C1.18108 11.7902 1.02015 11.8832 0.933027 12.034C0.845892 12.1848 0.845892 12.3707 0.933027 12.5216C1.02016 12.6724 1.18109 12.7653 1.35523 12.7653H2.08658V13.4967C2.08658 13.671 2.17955 13.8319 2.33036 13.9189C2.48118 14.006 2.66712 14.006 2.81793 13.9189C2.96875 13.8319 3.06171 13.6709 3.06171 13.4967V12.7653H9.76424L10.7532 15.6072C10.8 15.7343 10.8971 15.8366 11.0217 15.8895C11.1465 15.9425 11.2874 15.9416 11.4113 15.8869C11.5353 15.8323 11.6312 15.7288 11.6762 15.6011L12.7913 12.2561L16.1363 11.1411C16.264 11.0961 16.3675 11.0002 16.422 10.8762C16.4766 10.7523 16.4775 10.6113 16.4245 10.4866C16.3715 10.362 16.2694 10.2649 16.1423 10.2181L16.1425 10.2179ZM7.69354 11.7901H3.06165V2.52634H12.3254V8.8897L11.1907 8.49486L12.1826 7.50306V7.50294C12.2734 7.41117 12.3242 7.28737 12.3242 7.15823C12.3242 7.0292 12.2734 6.90528 12.1826 6.81352L8.03828 2.6692C7.94686 2.57778 7.82283 2.52636 7.69357 2.52636C7.5643 2.52636 7.44026 2.57778 7.34886 2.6692L3.20454 6.81352C3.11312 6.90494 3.0617 7.02898 3.0617 7.15823C3.0617 7.28751 3.11312 7.41154 3.20454 7.50294L7.34886 11.6473C7.44028 11.7388 7.56431 11.7901 7.69357 11.7901C7.82284 11.7901 7.94688 11.7388 8.03828 11.6473L9.0302 10.6555L9.42504 11.7901L7.69354 11.7901ZM8.8289 7.67292C8.71308 7.63435 8.58702 7.64042 8.47535 7.68982C8.3637 7.73922 8.27454 7.82838 8.22514 7.94003C8.17574 8.05169 8.16967 8.17774 8.20824 8.29358L8.67414 9.6325L7.69352 10.613L4.2385 7.15828L7.69352 3.70356L11.1485 7.15828L10.1679 8.1389L8.8289 7.67292ZM12.2516 11.408C12.106 11.4567 11.9919 11.5708 11.9433 11.7164L11.2037 13.935L9.46051 8.92523L14.4703 10.6685L12.2516 11.408Z"
          fill="black"
        />
      </svg>
    ),
  },
  {
    name: 'in_contestability',
    label: 'Incontestability Service',
    description:
      'Incontestable status provides advantages in the event of a trademark dispute.',
    category: 'renewal',
    price: 799,
    priceType: 'direct',
    icon: () => (
      <svg
        width="17"
        height="14"
        viewBox="0 0 17 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.1425 10.2179L13.3006 9.22896V2.52644H14.032C14.2062 2.52644 14.3672 2.43347 14.4542 2.28265C14.5413 2.13183 14.5413 1.9459 14.4542 1.79508C14.3672 1.64427 14.2062 1.5513 14.032 1.5513H13.3006V0.819951C13.3006 0.645804 13.2077 0.48487 13.0568 0.397748C12.906 0.310614 12.7201 0.310614 12.5693 0.397748C12.4185 0.484883 12.3255 0.645816 12.3255 0.819951V1.5513H3.06171V0.819951C3.06171 0.645804 2.96875 0.48487 2.81793 0.397748C2.66711 0.310614 2.48117 0.310614 2.33036 0.397748C2.17955 0.484883 2.08658 0.645816 2.08658 0.819951V1.5513H1.35523C1.18108 1.5513 1.02015 1.64427 0.933027 1.79508C0.845892 1.9459 0.845892 2.13184 0.933027 2.28265C1.02016 2.43347 1.18109 2.52644 1.35523 2.52644H2.08658V11.7902H1.35523C1.18108 11.7902 1.02015 11.8832 0.933027 12.034C0.845892 12.1848 0.845892 12.3707 0.933027 12.5216C1.02016 12.6724 1.18109 12.7653 1.35523 12.7653H2.08658V13.4967C2.08658 13.671 2.17955 13.8319 2.33036 13.9189C2.48118 14.006 2.66712 14.006 2.81793 13.9189C2.96875 13.8319 3.06171 13.6709 3.06171 13.4967V12.7653H9.76424L10.7532 15.6072C10.8 15.7343 10.8971 15.8366 11.0217 15.8895C11.1465 15.9425 11.2874 15.9416 11.4113 15.8869C11.5353 15.8323 11.6312 15.7288 11.6762 15.6011L12.7913 12.2561L16.1363 11.1411C16.264 11.0961 16.3675 11.0002 16.422 10.8762C16.4766 10.7523 16.4775 10.6113 16.4245 10.4866C16.3715 10.362 16.2694 10.2649 16.1423 10.2181L16.1425 10.2179ZM7.69354 11.7901H3.06165V2.52634H12.3254V8.8897L11.1907 8.49486L12.1826 7.50306V7.50294C12.2734 7.41117 12.3242 7.28737 12.3242 7.15823C12.3242 7.0292 12.2734 6.90528 12.1826 6.81352L8.03828 2.6692C7.94686 2.57778 7.82283 2.52636 7.69357 2.52636C7.5643 2.52636 7.44026 2.57778 7.34886 2.6692L3.20454 6.81352C3.11312 6.90494 3.0617 7.02898 3.0617 7.15823C3.0617 7.28751 3.11312 7.41154 3.20454 7.50294L7.34886 11.6473C7.44028 11.7388 7.56431 11.7901 7.69357 11.7901C7.82284 11.7901 7.94688 11.7388 8.03828 11.6473L9.0302 10.6555L9.42504 11.7901L7.69354 11.7901ZM8.8289 7.67292C8.71308 7.63435 8.58702 7.64042 8.47535 7.68982C8.3637 7.73922 8.27454 7.82838 8.22514 7.94003C8.17574 8.05169 8.16967 8.17774 8.20824 8.29358L8.67414 9.6325L7.69352 10.613L4.2385 7.15828L7.69352 3.70356L11.1485 7.15828L10.1679 8.1389L8.8289 7.67292ZM12.2516 11.408C12.106 11.4567 11.9919 11.5708 11.9433 11.7164L11.2037 13.935L9.46051 8.92523L14.4703 10.6685L12.2516 11.408Z"
          fill="black"
        />
      </svg>
    ),
  },
]
